import { Routes } from "@angular/router";
import { authGuard } from "./libs/guards/auth.guard";
import { guestGuard } from "./libs/guards/guest.guard";

const errorPage = () =>
  import("./domain/shared/presentation/error-page/error-page.component").then(
    (m) => m.ErrorPageComponent
  );

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    canActivate: [guestGuard],
    loadComponent: () =>
      import("./domain/welcome/presentation/welcome.component").then((m) => m.WelcomeComponent)
  },
  {
    path: "sign-up",
    canActivate: [guestGuard],
    loadComponent: () =>
      import("./domain/auth/presentation/sign-up/sign-up.component").then((m) => m.SignUpComponent)
  },
  {
    path: "sign-in",
    canActivate: [guestGuard],
    loadComponent: () =>
      import("./domain/auth/presentation/sign-in/sign-in.component").then((m) => m.SignInComponent)
  },
  {
    path: "logout",
    loadComponent: () =>
      import("./domain/auth/presentation/logout/logout.component").then((m) => m.LogoutComponent)
  },
  {
    path: "terms",
    loadComponent: () =>
      import("./domain/legal/presentation/legal-document/legal-document.component").then(
        (m) => m.LegalDocumentComponent
      ),
    data: { doc: "terms" }
  },
  {
    path: "privacy",
    loadComponent: () =>
      import("./domain/legal/presentation/legal-document/legal-document.component").then(
        (m) => m.LegalDocumentComponent
      ),
    data: { doc: "privacy" }
  },
  // Error pages
  { path: "404", loadComponent: errorPage, data: { status: 404 } },
  { path: "403", loadComponent: errorPage, data: { status: 403 } },
  { path: "500", loadComponent: errorPage, data: { status: 500 } },

  // Protected routes
  {
    path: "",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./domain/shared/presentation/authenticated-layout/authenticated-layout.component").then(
        (m) => m.AuthenticatedLayoutComponent
      ),
    children: [
      {
        path: "dashboard",
        loadComponent: () =>
          import("./domain/dashboard/presentation/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent
          )
      },
      {
        path: "profile",
        loadComponent: () =>
          import("./domain/profile/presentation/shell/profile-shell.component").then(
            (m) => m.ProfileShellComponent
          ),
        children: [
          { path: "", redirectTo: "update", pathMatch: "full" },
          {
            path: "update",
            loadComponent: () =>
              import("./domain/profile/presentation/update/profile-update.component").then(
                (m) => m.ProfileUpdateComponent
              )
          },
          {
            path: "skills",
            loadComponent: () =>
              import("./domain/profile/presentation/skills/profile-skills.component").then(
                (m) => m.ProfileSkillsComponent
              )
          },
          {
            path: "security",
            loadComponent: () =>
              import("./domain/profile/presentation/security/profile-security.component").then(
                (m) => m.ProfileSecurityComponent
              )
          },
          {
            path: "privacy",
            loadComponent: () =>
              import("./domain/profile/presentation/privacy/profile-privacy.component").then(
                (m) => m.ProfilePrivacyComponent
              )
          }
        ]
      },
      // Organization protected routes
      {
        path: "organizations/new",
        loadComponent: () =>
          import("./domain/organization/presentation/create/organization-create.component").then(
            (m) => m.OrganizationCreateComponent
          )
      },
      // Events
      {
        path: "events",
        loadComponent: () =>
          import("./domain/event/presentation/list/event-list.component").then(
            (m) => m.EventListComponent
          )
      },
      {
        path: "community",
        loadComponent: () =>
          import("./domain/community/presentation/list/community-list.component").then(
            (m) => m.CommunityListComponent
          )
      },
      {
        path: "my-events",
        loadComponent: () =>
          import("./domain/event/presentation/my-registrations/my-registrations.component").then(
            (m) => m.MyRegistrationsComponent
          )
      },
      {
        path: "notifications",
        loadComponent: () =>
          import("./domain/notification/presentation/list/notification-list.component").then(
            (m) => m.NotificationListComponent
          )
      },
      {
        path: "check-in",
        loadComponent: () =>
          import("./domain/event/presentation/check-in/check-in-scanner.component").then(
            (m) => m.CheckInScannerComponent
          )
      },
      {
        path: "organizations/:id",
        loadComponent: () =>
          import("./domain/organization/presentation/detail/organization-detail.component").then(
            (m) => m.OrganizationDetailComponent
          )
      },
      {
        path: "organizations/:id/manage",
        loadComponent: () =>
          import("./domain/organization/presentation/manage/organization-manage-shell.component").then(
            (m) => m.OrganizationManageShellComponent
          )
      },
      {
        path: "events/:id",
        loadComponent: () =>
          import("./domain/event/presentation/detail/event-detail.component").then(
            (m) => m.EventDetailComponent
          )
      },
      {
        path: "events/:id/manage",
        loadComponent: () =>
          import("./domain/event/presentation/manage/event-manage-shell.component").then(
            (m) => m.EventManageShellComponent
          )
      }
    ]
  },

  // Catch-all — must be last
  { path: "**", loadComponent: errorPage, data: { status: 404 } }
];
